import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDynamicContainer]',
  standalone: true,
})
export class DynamicContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
    console.log('dynamic-container.directive.constructor  ');
  }
}
